<template>
    <v-container>
        <v-row>
            <v-col>
                <v-row>
                    <v-col>
                        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-card>
                            <v-data-table :headers="headers" :items="store.nonWhitelistedStats" :loading="isLoading">
                                <template #item.phoneCountryCode="{ item }">
                                    {{ mapCountryCodeToName(item.phoneCountryCode) }}
                                </template>
                                <template #item.profileCount="{ item }">
                                    {{ item.profileCount }}
                                </template>
                                <template #item.controls="{ item }">
                                    <div class="controls-container" style="text-align: right">
                                        <v-btn
                                            class="view-link"
                                            icon
                                            variant="text"
                                            @click.prevent="goToNonWhitelistedProfiles(item.phoneCountryCode)"
                                        >
                                            <v-icon class="view-icon" icon="mdi-eye" />
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { useProfileWhitelistStore } from './profileWhitelistStore';
import { useCommonStore } from '@/features/shared/commonStore';
import { PhoneCountryCode } from '@/features/shared/models';
import { ProfileWhitelistRels } from '@/features/profileWhitelist/rels';
import { useRouter } from 'vue-router';

const store = useProfileWhitelistStore();
const commonStore = useCommonStore();
const router = useRouter();

const breadcrumbs = [
    {
        title: 'Ikke-hviteliste profiler'
    }
];

const headers = [
    {
        title: 'Landskode',
        key: 'phoneCountryCode',
        sortable: true
    },
    {
        title: 'Antall profiler',
        key: 'profileCount',
        sortable: true
    },
    {
        title: '',
        key: 'controls',
        sortable: false
    }
];

const isLoading = ref(true);
const phoneCountryCodes = ref<Array<PhoneCountryCode>>([]);

onMounted(async () => {
    isLoading.value = true;

    phoneCountryCodes.value = await commonStore.getCountryPhoneCodes();
    await store.loadNonWhitelistedStats();

    isLoading.value = false;
});

function mapCountryCodeToName(phoneCountryCode?: string): string {
    if (!phoneCountryCode) return '';
    const country = phoneCountryCodes.value.find((code: PhoneCountryCode) => code.code === phoneCountryCode);
    return country ? country.name : phoneCountryCode;
}

function goToNonWhitelistedProfiles(phoneCountryCode: string) {
    router.push({
        name: ProfileWhitelistRels.FindNonWhitelistedProfiles,
        params: { phoneCountryCode }
    });
}
</script>

<style scoped>
.add-new {
    float: right;
    margin-top: 10px;
}

.button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.view-link {
    display: flex;
    align-items: center;
    text-decoration: none;
}

.view-icon {
    margin-right: 4px;
    font-size: 21px;
}

.controls-container {
    display: flex;
    justify-content: flex-end;
    text-align: right;
    padding-right: 40px;
}
</style>
